import * as Sentry from '@sentry/react'
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'
import { Providers } from './providers'
import App from './App'
import './index.css'

// Before createRoot, so an error thrown while the tree first renders is caught.
// Vite inlines VITE_ vars at build time; an unset DSN leaves the SDK disabled,
// which is what we want for anyone building without Sentry credentials.
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  // Router-aware so transactions are named by route pattern — plain browser
  // tracing would name them by URL and make /vendors/<uuid> its own transaction.
  integrations: [
    Sentry.reactRouterBrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Providers>
        <App />
      </Providers>
    </BrowserRouter>
  </React.StrictMode>
)
